import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { AsnDetailFullDto } from '../../../interfaces/Asn/AsnDetailFullDto'

export const getAsnDetailView = (asnId: number, packingListId: number) => {
  const url = new URL(
    `${ApiConfig.AsnApi}/GetAsnDetailView/${asnId}/${packingListId}`
  )
  return axios.get<AsnDetailFullDto>(url.toString())
}

export const downloadAsnFile = (processId: number) => {
  const url = new URL(`${ApiConfig.ProcessApi}/GetFile/${processId}`)
  return axios.get(url.toString())
}

export const downloadAsnResultFile = (processId: number) => {
  const url = new URL(`${ApiConfig.ProcessApi}/GetResultFile/${processId}`)
  return axios.get(url.toString())
}
